import { render, staticRenderFns } from "./FilteredProductList.vue?vue&type=template&id=18e79ade&scoped=true&"
import script from "./FilteredProductList.vue?vue&type=script&lang=js&"
export * from "./FilteredProductList.vue?vue&type=script&lang=js&"
import style0 from "./FilteredProductList.vue?vue&type=style&index=0&id=18e79ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e79ade",
  null
  
)

export default component.exports